import CsAlarmList from './CsAlarmList.vue'
CsAlarmList.install = function (Vue) {
  Vue.component(CsAlarmList.name, CsAlarmList);
}

import WsAlarmList from './WsAlarmList.vue'
WsAlarmList.install = function (Vue) {
  Vue.component(WsAlarmList.name, WsAlarmList);
}

export default [CsAlarmList,WsAlarmList]



// WEBPACK FOOTER //
// ./src/components/alarmlist/index.js